<template>
  <div class="question">
    <p class="question-text">
      {{ question.question }}
    </p>
    <div class="answers" :class="{
    'has-answer': answer > -1
  }">
      <div v-for="(ans, index) in answers" :key="index" :data-index="ans.index">
        <img :src="ans.icon" @click="setAnswer(ans.index)"
             :class="{ active: answer === ans.index}"/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {inject, ref} from "vue";
import {knuthShuffle} from "knuth-shuffle";
import {recordAnswer} from "@/ts/helpers";

const props = defineProps(['question']);

const emit = defineEmits(['result']);

const answer = ref(-1);

const setAnswer = (ans: number) => {

  if (answer.value > -1) {
    return;
  }

  answer.value = ans;

  recordAnswer(
      5,
      props.question.questionId,
      ans
  );

  emit('result', ans);
};

const { answers, shuffle } = inject('illuminate', { answers: ref([]), shuffle: () => {} });

shuffle();
</script>

<style scoped lang="scss">
.answers {
  display: grid;
  justify-items: center;
  //justify-content: space-between;
  gap: 20px;

  @media screen and (orientation: landscape) {
    grid-template-columns: repeat(3, 1fr);
    //grid-template-columns: repeat(3, minmax(101px, min(172px, calc((100vh - 300px) / 2))))
  }
  @media screen and (orientation: portrait) {
    grid-template-columns: repeat(2, 1fr);
    //grid-template-columns: repeat(2, minmax(101px, min(172px, calc((100vh - 300px) / 3))))
  }

  @media screen and (min-width: 1024px) {
    gap: 32px 48px;
  }

  img {
    width: 100%;
    max-width: min(172px, calc((100vh - 300px) / 3));
    transition: opacity .4s ease-out, box-shadow .4s ease-out;
    border: 1px solid rgba(154, 151, 158, 0.50);
    border-radius: 100%;
    cursor: pointer;

    @media screen and (orientation: landscape) {
      max-width: min(172px, calc((100vh - 300px) / 2));
      max-width: min(172px, calc((100svh - 300px) / 2));
    }
    @media screen and (orientation: portrait) {
      max-width: min(172px, calc((100vh - 300px) / 3));
      max-width: min(172px, calc((100svh - 300px) / 3));
    }
  }

  &.has-answer {
    img:not(.active) {
      opacity: 0;
    }

    img.active {
      box-shadow: 4px 0px 4px 0px rgba(0, 0, 0, 0.20), 0px 0px 6px 1px rgba(255, 230, 71, 0.30), 0px 0px 26px 2px rgba(129, 202, 210, 0.20);
    }
  }
}

.question {
  padding: 40px 24px 0;
  display: flex;
  flex-flow: column;
  gap: 26px;
  max-width: 654px;
}

.question-text {
  color: var(--iqos-white, #FFFDFB);
  /* text-shadow */
  text-shadow: 0px 0px 18px rgba(0, 0, 0, 0.40);
  /* base-text */
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 24px */
  margin: 0;

  @media screen and (min-width: 1024px) {
    min-height: 48px;
    font-size: 20px;
  }
}
</style>
